import { FetchMembershipAnalyticsStatisticsParams } from '@models/membership/MembershipAnalyticsStatistics'
import { FetchUserAnalyticsStatisticsParams } from '@models/user/UserAnalyticsStatistics'
import { FetchVenueAnalyticsStatisticsParams } from '@models/venue/VenueAnalyticsStatistics'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { ANALYTICS_STATISTICS_URL } from '@utils/urls'

type FetchAnalyticsStatisticsParams =
  | FetchUserAnalyticsStatisticsParams
  | FetchVenueAnalyticsStatisticsParams
  | FetchMembershipAnalyticsStatisticsParams

const fetchAnalyticsStatistics = <T>(params: FetchAnalyticsStatisticsParams) =>
  SBAPI.Fetch<T>(ANALYTICS_STATISTICS_URL, params)

export { fetchAnalyticsStatistics }
